import React, { useEffect, useState } from 'react';

import Typography from '@mui/material/Typography'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Link from '@mui/material/Link'
import { Button, Grid } from '@mui/material'

import filterIcon from './../../../../assets/icons/filter 1.png'
import searchIcon from './../../../../assets/icons/searchIcon 1.png'
import AddItemDialogComponent from './AddItemDialog.tsx'

import FilterComponents from '../FilterComponents.tsx';
import SectionTable from '../SectionTable.tsx';
import AddSectionDialog from '../AddSectionDialog.tsx';
import burger from './../../../../assets/icons/burger.png'
import edit from './../../../../assets/icons/edit.png'
import bin from './../../../../assets/icons/recycle-binColor.png'
import ediPencil from './../../../../assets/icons/editPencil.png'
//table
import arrowUp from './../../../../assets/icons/arrowup.png'
import arrowDown from './../../../../assets/icons/arrowDown.png'
import Paper from '@mui/material/Paper';

import Box from '@mui/material/Box'
import Tab from '@mui/material/Tab'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import SectionItemsDialog from '../SectionItemsDialog/SectionItemsDialog.tsx';
//table end
import CustomDataGrid from '../../../components/CustomDataGrid/CustomDataGrid.tsx';
import axios from 'axios';
import EditSection from '../EditSection/EditSection.tsx';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingView from '../../../components/LoadingView/LoadingView';
import AddMenuDialog from '../AddMenuDialog.tsx';
import KeywordDialog from '../KeywordDialog.tsx';
import SweetAlertModal from '../../../components/SweetAlertModal/SweetAlertModal';
import { X } from 'lucide-react';

const AddKeyword = () => {

    const[open, setOpen]=useState(false);
    const [openConfirmaitonModal, setopenConfirmaitonModal]=useState(false);
        const [searchQuery, setSearchQuery] = useState("");
          const [Loading, setLoading] = React.useState(false);

    const handleClickOpen = () => {
        // console.log(selectedMenu);
        // setOpenAddSection(true);
        // setDialogType('add');
        setOpen(true)
    }
    const onDialogClose=(props)=>{
        setOpen(props)
        setOpenEditKeyword(props)
        
    }

    const errorToast=(msg)=>{
        toast.error(msg, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const apiAddress = process.env.REACT_APP_SECRET;

    const [selectedDataRows, setSelectedDatarows] = React.useState([]);
    const [selectedDataRowsCount, setSelectedDatarowsCount] = React.useState([]);
    const getselectedData = (props) => {
       console.log(props)
       setSelectedDatarows(props)
    }
    const deleteBin = () => {
        axios
            .put(apiAddress + "/api/Keyword/DeleteKeyword", selectedDataRows)
            .then((response) => {
                console.log(response.data);
                toast.success("Suuccesfully deleted", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                  });
                  loadKeyword()
            });
            setopenConfirmaitonModal(false)
      
    }

    const reloadKeyword=()=>{
        loadKeyword()
    }
const[OpenEditKeyword, setOpenEditKeyword]=useState(false)
const[EditKeywordObj, setEditKeywordObj]=useState()
    const onEditClick = (props) => {
       
        var obj=dataRows.find(x=>x.id==props)
        console.log(obj)
        setEditKeywordObj(obj)
        setOpenEditKeyword(true)
      }
    const columnsdatas = [
    
        {
            field: 'name', headerName: 'Keyword Name', renderCell: (params) =>
                <div className='d-flex ' style={{ gap: "10px" }}>
                    <span
                        // onClick={() => { setsectionItemsToggle(true); setsectionItemsdialogType(params.value) }} 
                        style={{ color: "blue", cursor: "pointer" }}>{params.value}
                    </span>
                    <div style={{ color: "blue", cursor: "pointer" }}
                    onClick={() => { onEditClick(params.row.id) }}
                    >
                        <img src={ediPencil} alt="" style={{ width: "1rem" }} />
                    </div>

                </div>, align: 'center', headerAlign: 'center', flex: 1
        },
        {
            field: 'restaurantname', headerName: 'Restaurant Name', renderCell: (params) =>
                <div className='d-flex ' style={{ gap: "10px" }}>
                    <span>{params.value}
                    </span>


                </div>, align: 'center', headerAlign: 'center', flex: 1
        }
    ];
    const [dataRows, setDataRows] = useState([])
    const [dataRowsCollection, setdataRowsCollection] = useState([])
    const Restauranttoken = JSON.parse(localStorage.getItem('restaurant'));

    const loadKeyword=async()=>{
        setLoading(true);
      await  axios
        .get(apiAddress + "/api/Keyword/getkeywordbyrestaurantid?restaurantId=" +Restauranttoken.id)
        .then((response) => {
            console.log(response.data);
            var list = [];
            response.data.map((dt, i) => {
                var obj = {
                    id: dt.id,
                    name: dt.keywordName,
                    restaurantname: dt.name
                }
                list.push(obj)
            })
            setDataRows(list);
            setLoading(false);
        });
    }
    useEffect(() => {
        loadKeyword()
    }, [])

    
     const filteredRows = dataRows.filter((item) =>
  item.name?.toLowerCase().includes(searchQuery.toLowerCase())
);
    return (
        <div>
            <ToastContainer></ToastContainer>
            <LoadingView open={Loading} close={() => { setLoading(false) }} />
            <SweetAlertModal headerText={"Are you sure?"} bodyText={"You want to delete this?"} open={openConfirmaitonModal} onyes={deleteBin} close={() => { setopenConfirmaitonModal(false) }} />

            <Grid
                container
                alignItems="center"
                justifyContent="space-between"
                mt={2}
                mb={2}
            >
                <Grid item>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item>
                            <Button
                                color="primary"
                                size="medium"
                                variant="contained"
                                style={{ borderRadius: '50%', minWidth: 'auto' }}
                                onClick={handleClickOpen}
                            >
                                +
                            </Button>
                        </Grid>
                        <Grid item>
                            <img src={filterIcon} alt="" style={{ width: '1rem' }} />
                        </Grid>
                        <Grid item>Add Filter</Grid>

                        <Grid item>
                            <div className='roundedCorner'>
                                <img src={bin} alt="" style={{ width: '1rem' }} onClick={() => {selectedDataRows.length==0? errorToast("Please select any keyword") : setopenConfirmaitonModal(true) }} />
                            </div>
                        </Grid>
                        <Grid item>

                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid container flexDirection={'column'} alignItems={'center'}>
                        <Grid item>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                border: "1px solid #ccc",
                padding: "6px 10px",
                borderRadius: "6px",
                background: "#fff",
              }}
            >
              <img
                src={searchIcon}
                alt=""
                style={{ width: "1rem", opacity: 0.7 }}
              />
        
                  <div
  style={{
    position: "relative",
    display: "flex",
    alignItems: "center",
  }}
>
  <input
    type="text"
    placeholder="Search..."
    style={{
      border: "none",
      outline: "none",
      fontSize: "14px",
      paddingRight: "22px", 
    }}
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
  />

  {searchQuery && (
    <X
      size={16}
      style={{
        position: "absolute",
        right: "4px",
        cursor: "pointer",
        color: "#888",
      }}
      onClick={() => setSearchQuery("")}
    />
  )}
</div>
            </div>
                        </Grid>
                        <Grid item></Grid>
                    </Grid>
                </Grid>
            </Grid>
{
  dataRows.length > 0 ? (
    selectedDataRows.length > 0 ? (
      <CustomDataGrid
        columns={columnsdatas}
        dataRows={filteredRows}
        getselectedData={getselectedData}
        selectedRows={selectedDataRows}
        isLoading={Loading}
      />
    ) : (
      <CustomDataGrid
        columns={columnsdatas}
        dataRows={filteredRows}
        getselectedData={getselectedData}
        isLoading={Loading}
      />
    )
  ) : (
    "No Data found"
  )
}

            {open?(
            <KeywordDialog open={open} onHandleKeywordDialog={onDialogClose} reloadKeyword={reloadKeyword}/>
            ):""}
            <KeywordDialog open={OpenEditKeyword} onHandleKeywordDialog={onDialogClose} editKeywordData={EditKeywordObj} reloadKeyword={reloadKeyword}/>
        </div>
    );
};

export default AddKeyword;